<div *transloco="let t" class="onboarding-page-container">
  <div class="title">
    {{ t('onboarding.thirdPage.partOne') }}
    <lib-pill-logo [companyName]="companyName()!" [companyLogo]="companyLogo()!" [size]="Size.BIG"></lib-pill-logo>
    @if (yearsMembership() > 1) {
      {{ t('onboarding.thirdPage.partTwoMoreYears', {years: yearsMembership()}) }}
    } @else {
      {{ t('onboarding.thirdPage.partTwoSingleYear') }}
    }
  </div>
  <img class="star star-thin" ngSrc="assets/images/onboarding/star-thin.png" alt="multicolored start" priority
       height="200" width="162">
  <img class="star calendar" ngSrc="assets/images/onboarding/calendar-as-background.png" alt="multicolored start"
       priority height="360" width="360">
</div>
